import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import i18n from '../../../app/i18n';

import useForm from '../../../lib/hooks/useForm';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const validationSchema = yup.object({
  password: yup
    .string()
    .required(i18n.t('accountSettings:passwordForm.errors.blankPassword'))
    .min(12, i18n.t('accountSettings:passwordForm.errors.minLength')),
  passwordConfirmation: yup
    .string()
    .required(
      i18n.t('accountSettings:passwordForm.errors.requiredConfirmation'),
    )
    .oneOf(
      [yup.ref('password')],
      i18n.t('accountSettings:passwordForm.errors.requiredConfirmation'),
    ),
});

const updatePassword = ({ password, passwordConfirmation }) => {
  const data = {
    password,
    password_confirmation: passwordConfirmation,
  };

  return api({
    method: 'patch',
    url: '/api/account_settings/update_password',
    data,
  });
};

const usePasswordForm = () => {
  const { t } = useTranslation(['shared, accountSettings']);
  const { showSuccess } = useNotification();
  const { mutate } = useMutation(updatePassword, {
    onSuccess: () => {
      showSuccess({
        content: t('accountSettings:passwordForm.success'),
        title: t('accountSettings:passwordForm.title'),
      });
    },
  });

  const initialValues = {
    password: '',
    passwordConfirmation: '',
  };

  const onSubmit = values => {
    mutate(values);
  };

  const form = useForm({
    onSubmit,
    initialValues,
    validationSchema,
  });

  const handleError = name => {
    const isEmpty = form.values[name].length === 0;
    return !isEmpty && form.inputError(name);
  };

  return { ...form, handleError };
};

export default usePasswordForm;
